import React, { useContext } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ROUTER_PATHS } from '~/constants';
import { useRoleCan } from '~/hooks';
import { PORTAL_ROUTES_DEFINITION } from '~/constants/PORTAL_ROUTES_DEFINITION';
import { AuthContext } from '~/contexts';
import { RolesEnum } from '~/utils/roles';
import { useFeatureFlags } from '~/contexts/FeatureFlagsContext/FeatureFlagsContext';
import { FeatureFlagContextData } from '~/contexts/FeatureFlagsContext/types';

export const PortalRoutes: React.VFC = () => {
  const authContext = useContext(AuthContext);
  const features = useFeatureFlags();

  const userRoutes = PORTAL_ROUTES_DEFINITION.filter(routeDefinition => {
    // checar primeiro se a feature esta habilitada
    if (
      routeDefinition.featureFlagName &&
      !features[routeDefinition.featureFlagName as keyof FeatureFlagContextData]
    ) {
      return false;
    }

    if (routeDefinition.checkAccess) {
      return routeDefinition.checkAccess(authContext, routeDefinition.roles);
    }
    // tipo de acesso e funcao devem permitir o acesso
    if (routeDefinition.accessTypes) {
      return routeDefinition.accessTypes.includes(authContext.user.accessType);
    }

    if (routeDefinition.roles) {
      const keys = Object.keys(RolesEnum) as (keyof typeof RolesEnum)[];
      const foundKey = keys.find(
        key => RolesEnum[key] === authContext.user.funcao.toLocaleLowerCase(),
      );
      if (!foundKey) {
        // nao encontrou a funcao do usuario
        console.log(
          'funcao nao encontrada',
          authContext.user.funcao.toLocaleLowerCase(),
        );
        return false;
      }
      return routeDefinition.roles.includes(RolesEnum[foundKey]);
    }
    return false;
  });
  return (
    <Switch>
      {userRoutes.map(route => (
        <Route exact component={route.component} path={route.path} />
      ))}
      {useRoleCan({ roles: ['técnico'] }) ? (
        <Redirect to={ROUTER_PATHS.PORTAL.SINISTERS} />
      ) : (
        <Redirect to={ROUTER_PATHS.PORTAL.HOME} />
      )}
    </Switch>
  );
};
